import ChartBoink0JaarTmGroep8 from "../../../../src/client/boink/0-jaar-tm-groep-8.json";
import * as React from 'react';
export default {
  ChartBoink0JaarTmGroep8,
  React
};